<template>
  <nuxt-layout>
    <nuxt-page></nuxt-page>
  </nuxt-layout>
</template>

<script lang="ts" setup>
const config = useRuntimeConfig()

useHead({
  titleTemplate: (title) => {
    return title ? `${title} | Rädda Djuren-klubben` : 'Rädda Djuren-klubben'
  },
  meta: [
    {
      name: 'content-language',
      content: 'SV-se',
    },
  ],
  link: [
    {
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico',
    },
  ],
  script: [
    {
      'data-cookieconsent': 'ignore',
      innerHTML: `var _mtm = window._mtm = window._mtm || [];
            _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
            (function() {
            var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
            g.async=true; g.src='https://cdn.matomo.cloud/djurensratt.matomo.cloud/container_NE9tmkKa.js'; s.parentNode.insertBefore(g,s);
            })();`,
    },
    {
      innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${config.public.GOOGLE_TM_ID}');`,
    },
  ],
})

const siteUrl = useRuntimeConfig().public.SITE_URL

useSeoMeta({
  charset: 'utf-8',
  viewport: 'width=device-width, initial-scale=1',
  // Open Graph
  // Test on: https://developers.facebook.com/tools/debug/
  ogDescription:
    'Rädda Djuren är en unik klubb för alla barn som bryr sig om djur. Vårt uppdrag är att sprida fakta om djur och att lära ut empati för djur till barn och unga.',
  description:
    'Rädda Djuren är en unik klubb för alla barn som bryr sig om djur. Vårt uppdrag är att sprida fakta om djur och att lära ut empati för djur till barn och unga.',
  ogSiteName: 'Rädda Djuren-klubben',
  ogType: 'website',
  ogUrl: siteUrl,
  ogTitle: 'Rädda Djuren-klubben',
  ogImage: new URL('/share.png', siteUrl).toString(),
  ogImageSecureUrl: new URL('/share.png', siteUrl).toString(),
  ogImageAlt: 'Rädda Djuren-klubben',
  // Twitter
  // Test on: https://cards-dev.twitter.com/validator
  twitterCard: 'summary_large_image',
  twitterSite: '@raddadjuren',
  twitterTitle: 'Rädda Djuren-klubben',
  twitterDescription:
    'Rädda Djuren är en unik klubb för alla barn som bryr sig om djur. Vårt uppdrag är att sprida fakta om djur och att lära ut empati för djur till barn och unga.',
  twitterImage: new URL('/share.png', siteUrl).toString(),
})
</script>
